import { X } from "lucide-react";

/** Filtro exato vindo de outra seção (ex.: "Bots de joao_silva"), com botão para remover. */
export default function FilterChip({ label, onClear }) {
    return (
        <span className="admin-filter-chip">
            {label}
            <button type="button" aria-label="Remover filtro" title="Remover filtro" onClick={onClear}>
                <X size={13} />
            </button>
        </span>
    );
}
